<template>
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>衣单号码</th>
          <th>姓名</th>
          <th>手机号</th>
          <th>创建日期</th>
          <th>衣服件数</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in tickets" :key="index" @click="onRowClick(item)">
          <td>{{item.idView}}</td>
          <td>{{item.user.profile.name}}</td>
          <td>{{item.user.profile.phone}}</td>
          <td>{{item.createAt | dt}}</td>
          <td>{{item.clotheRecords.length}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
``
<script>
export default {
  props: ['tickets'],
  methods: {
    onRowClick(item) {
      this.$emit('onRowClick', item)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/list/Tickets.vue